import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-106fe05c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ef-loader" }
const _hoisted_2 = {
  version: "1.1",
  id: "L3",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("animateTransform", {
  attributeName: "transform",
  dur: "1s",
  type: "rotate",
  from: "0 50 48",
  to: "360 50 52",
  repeatCount: "indefinite"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]


export default /*#__PURE__*/_defineComponent({
  props: {
  color: { type: String, default: '#1d467c' },
},
  setup(__props) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("circle", {
        fill: "none",
        stroke: __props.color,
        "stroke-width": "4",
        cx: "50",
        cy: "50",
        r: "44",
        style: {"opacity":"0.5"}
      }, null, 8, _hoisted_3),
      _createElementVNode("circle", {
        fill: __props.color,
        stroke: "white",
        "stroke-width": "3",
        cx: "8",
        cy: "54",
        r: "6"
      }, _hoisted_6, 8, _hoisted_4)
    ]))
  ]))
}
}

})